//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

const emptyRange = () => ({
  amountFrom: null,
  amountTo: null,
  profit: null,
});

export default {
  props: {
    value: { type: Boolean, default: false },
    data: { type: Object, default: () => ({}) },
    tab: { type: Number, default: 0 },
    isMerchant: { type: Boolean, default: false },
  },

  emits: ['save', 'input'],

  data() {
    return {
      activeTab: this.tab,
      payload: this.getEmptyPayload(),
      oldPayload: this.getEmptyPayload(),
    };
  },

  computed: {
    ...mapState('tradersFees', {
      isSourcePaymentMethods: 'usePaymentMethodSettingsAsCommissionSource',
    }),

    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    parameterName() {
      return this.isSourcePaymentMethods ? 'paymentMethodId' : 'currencyId';
    },

    currencyLabel() {
      if (this.payload.currencyName) return this.payload.currencyName;
      if (this.payload.id !== null && this.payload.id !== undefined) return String(this.payload.id);
      return this.$t('Currency');
    },

    isValid() {
      const allRanges = [
        ...this.payload.sellFeePercent,
        ...this.payload.sellProfitPercent,
        ...this.payload.buyFeePercent,
        ...this.payload.buyProfitPercent,
      ];
      return allRanges.every((range) => this.isRangeValid(range));
    },
  },

  methods: {
    getEmptyPayload() {
      return {
        id: null,
        currencyName: '',
        isEnabled: true,
        sellFeePercent: [emptyRange()],
        sellProfitPercent: [emptyRange()],
        buyFeePercent: [emptyRange()],
        buyProfitPercent: [emptyRange()],
      };
    },

    cloneRanges(ranges) {
      const list = Array.isArray(ranges) ? ranges : [];
      if (list.length === 0) return [emptyRange()];
      return list.map((range) => ({
        amountFrom: range?.amountFrom ?? null,
        amountTo: range?.amountTo ?? null,
        profit: range?.profit ?? null,
      }));
    },

    setPayload(value) {
      const id = value?.currencyId ?? value?.paymentMethodId ?? null;
      this.payload = {
        id,
        currencyName: value?.currencyName || value?.name || value?.title || value?.caption || '',
        isEnabled: value?.isEnabled ?? true,
        sellFeePercent: this.cloneRanges(value?.sellFeePercent),
        sellProfitPercent: this.cloneRanges(value?.sellProfitPercent),
        buyFeePercent: this.cloneRanges(value?.buyFeePercent),
        buyProfitPercent: this.cloneRanges(value?.buyProfitPercent),
      };
    },

    isRangeEmpty(range) {
      return [range.amountFrom, range.amountTo, range.profit]
        .every((v) => v === null || v === undefined || v === '');
    },

    isRangeValid(range) {
      if (this.isRangeEmpty(range)) return true;
      if (
        range.amountFrom === null
        || range.amountTo === null
        || range.profit === null
        || range.amountFrom === ''
        || range.amountTo === ''
        || range.profit === ''
      ) {
        return false;
      }
      if (range.amountFrom === 0 && range.amountTo === 0) return true;
      return Number(range.amountFrom) < Number(range.amountTo);
    },

    fromRules(range) {
      return [
        (v) => {
          if (range.amountTo === 0 && v === 0) return true;
          if (v === null || range.amountTo === null) return true;
          if (v >= range.amountTo) {
            return this.$t('From must be less than To');
          }
          return true;
        },
      ];
    },

    toRules(range, listName, index) {
      return [
        (v) => {
          if (range.amountTo === 0 && v === 0) return true;
          if (v === null || range.amountFrom === null) return true;
          if (v <= range.amountFrom) {
            return this.$t('To must be greater than From');
          }
          return true;
        },
        (v) => {
          if (range.amountFrom === null || v === null) return true;
          if (this.isRangeOverlapping(range.amountFrom, v, listName, index)) {
            return this.$t('Range overlaps with existing range');
          }
          return true;
        },
      ];
    },

    isRangeOverlapping(newFrom, newTo, listName, currentIndex) {
      if (newFrom === null || newTo === null || newFrom >= newTo) {
        return false;
      }

      const ranges = this.payload[listName] || [];
      return ranges.some((range, index) => {
        if (index === currentIndex) {
          return false;
        }
        return newFrom < range.amountTo && newTo > range.amountFrom;
      });
    },

    addRange(key) {
      this.payload[key].push(emptyRange());
    },

    removeRange(key, index) {
      this.payload[key].splice(index, 1);
    },

    normalizeRanges(ranges) {
      return (ranges || [])
        .filter((range) => !this.isRangeEmpty(range))
        .map((range) => ({
          amountFrom: Number(range.amountFrom),
          amountTo: Number(range.amountTo),
          profit: Number(range.profit),
        }));
    },

    handleClose() {
      this.model = false;
    },

    getVisibleFormRefs() {
      const refs = [];
      const { tab, isMerchant } = this;

      if (tab === 0) { // Pay Out tab
        if (isMerchant) {
          this.payload.sellFeePercent.forEach((_, index) => {
            refs.push(`form-sell-fee-${index}`);
          });
        } else {
          this.payload.sellProfitPercent.forEach((_, index) => {
            refs.push(`form-sell-profit-${index}`);
          });
        }
      } else { // Pay In tab
        if (isMerchant) {
          this.payload.buyFeePercent.forEach((_, index) => {
            refs.push(`form-buy-fee-${index}`);
          });
        }

        this.payload.buyProfitPercent.forEach((_, index) => {
          refs.push(`form-buy-profit-${index}`);
        });
      }

      return refs;
    },

    validateVisibleForms() {
      const formRefs = this.getVisibleFormRefs();
      let isValid = true;

      formRefs.forEach((refName) => {
        const form = this.$refs[refName];
        if (form && form.length) {
          form.forEach((f) => {
            if (!f.validate()) {
              isValid = false;
            }
          });
        } else if (form && !form.validate()) {
          isValid = false;
        }
      });

      return isValid;
    },

    handleSave() {
      const isFormValid = this.validateVisibleForms();
      const isRangeValid = this.isValid;

      if (!isFormValid) {
        console.error('handleSave: Form is not valid');
        return;
      }

      if (!isRangeValid) {
        console.error('handleSave: Range is not valid');
        return;
      }

      this.handleClose();

      this.$emit('save', {
        [this.parameterName]: this.payload.id,
        isEnabled: this.payload.isEnabled,
        sellFeePercent: this.normalizeRanges(this.payload.sellFeePercent),
        sellProfitPercent: this.normalizeRanges(this.payload.sellProfitPercent),
        buyFeePercent: this.normalizeRanges(this.payload.buyFeePercent),
        buyProfitPercent: this.normalizeRanges(this.payload.buyProfitPercent),
      });
    },
  },

  watch: {
    data: {
      handler(value) {
        this.setPayload(value);
      },
      immediate: true,
    },
    value(value) {
      this.activeTab = this.tab;
      if (!value) {
        this.payload = this.getEmptyPayload();
      }
    },
  },
};
